import { render, staticRenderFns } from "./SideBarSection.vue?vue&type=template&id=56ddb963&scoped=true&"
import script from "./SideBarSection.vue?vue&type=script&lang=js&"
export * from "./SideBarSection.vue?vue&type=script&lang=js&"
import style0 from "./SideBarSection.vue?vue&type=style&index=0&id=56ddb963&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ddb963",
  null
  
)

export default component.exports